export default __webpack_public_path__ + "static/media/lending-not-available.489fec20.svg";